import { DialogActions, DialogTitle } from '@aibees/shared/components';
import { Dialog, DialogContent, Fade, Stack } from '@mui/material';
import { memo } from 'react';
import { CreateActionBulkDialog } from '../../../create-action-bulk-dialog';
import { LabelManagement } from '../../../search-table-action-dialog-lists/components/label-management';
import * as SX from './sx';
import type { LabelActionDialogProps as Props } from './types';

const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) =>
  e.stopPropagation();
const PAPER_PROPS = { onMouseDown: stopPropagation };

const NOOP = () => {};

export const LabelActionDialog = memo(({ labelAction, type }: Props) => {
  const {
    isDialogOpen,
    isCreateDialogOpen,
    manageTitleDialog,
    dialogIcon,
    hasChanges,
    selectedItems,
    apiIsLoading,
    searchType,
    grouping,
    isLabel,
    titleDialog,
    placeholder,
    inputTitle,
    createDialogType,
    handleCloseDialog,
    handleOpenCreateDialog,
    handleSetItems,
    handleSubmit,
    handleClearAll,
    handleCloseCreateDialog,
    handleOpenDialog,
  } = labelAction;

  return (
    <>
      <Dialog
        open={isDialogOpen}
        fullWidth={true}
        maxWidth="xs"
        TransitionComponent={Fade}
        onClose={handleCloseDialog}
        PaperProps={PAPER_PROPS}
      >
        <DialogTitle
          title={manageTitleDialog}
          icon={dialogIcon}
          onClose={handleCloseDialog}
        />
        <DialogContent sx={SX.dialogContent} padding="normal">
          <Stack direction="row" gap={1} alignContent="center">
            <LabelManagement
              type={type}
              setItems={handleSetItems}
              onOpenDialog={handleOpenCreateDialog}
              searchType={searchType}
            />
          </Stack>
        </DialogContent>
        <DialogActions
          disabled={!hasChanges}
          submitTitle="Apply"
          hasClearButton={true}
          clearButtonProps={{
            disabled: !selectedItems?.length,
          }}
          onClear={handleClearAll}
          loading={apiIsLoading}
          onClose={handleCloseDialog}
          onSubmit={handleSubmit}
        />
      </Dialog>

      <CreateActionBulkDialog
        state={{
          value: isCreateDialogOpen,
          onFalse: handleCloseCreateDialog,
          onTrue: NOOP,
          onToggle: NOOP,
          setValue: NOOP,
        }}
        firstState={{
          value: isDialogOpen,
          onFalse: handleCloseDialog,
          onTrue: handleOpenDialog,
          onToggle: NOOP,
          setValue: NOOP,
        }}
        type={createDialogType}
        title={titleDialog}
        placeholder={placeholder}
        inputTitle={inputTitle}
        hasColor={isLabel}
        hasDescription={isLabel}
        grouping={grouping}
      />
    </>
  );
});

LabelActionDialog.displayName = 'LabelActionDialog';
